module.exports = __webpack_public_path__ + "img/project3_medium.0acf6755.webp";